import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL

function ParseAPIErrors(error) {
  error.response.data.error.map(error => {
    Vue.prototype.$toasted.error(error.message)
  })

  return 0
}

// Se ejecuta tras cada request con axios
Vue.axios.interceptors.request.use(
  config => config,

  error => {
    ParseAPIErrors(error)
    return Promise.reject(error)
  }
)

// Se ejecuta tras cada response con axios
Vue.axios.interceptors.response.use(
  response => response,

  error => {
    ParseAPIErrors(error)
    return Promise.reject(error)
  }
)
